import { render, staticRenderFns } from "./GroupSiteTable.vue?vue&type=template&id=6608ac30&"
import script from "./GroupSiteTable.vue?vue&type=script&lang=js&"
export * from "./GroupSiteTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupSiteTable.vue?vue&type=style&index=0&id=6608ac30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports